// extracted by mini-css-extract-plugin
export default {"userProfileContainer":"UserPreview_userProfileContainer__2I7VR","avatarContainer":"UserPreview_avatarContainer__JU5DM","nameContainer":"UserPreview_nameContainer__1psEg"};